import { Persona, Persona__get_Name } from "../Shopfoo.Domain.Types/Security.js";
import { icon } from "./Icon.js";
import user from "@iconify-icons/fa6-solid/user";
import user_tag from "@iconify-icons/fa6-solid/user-tag";
import user_pen from "@iconify-icons/fa6-solid/user-pen";
import user_tie from "@iconify-icons/fa6-solid/user-tie";
import user_shield from "@iconify-icons/fa6-solid/user-shield";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import arrow_right_from_bracket from "@iconify-icons/fa6-solid/arrow-right-from-bracket";
import { AppTranslations__get_Home, TranslationPages_Home__get_Logout } from "../Shopfoo.Shared/Translations.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import user_lock from "@iconify-icons/fa6-solid/user-lock";

export function UserIcon(userName) {
    if (userName === Persona__get_Name(new Persona(0, []))) {
        return icon(user);
    }
    else if (userName === Persona__get_Name(new Persona(1, []))) {
        return icon(user_tag);
    }
    else if (userName === Persona__get_Name(new Persona(2, []))) {
        return icon(user_pen);
    }
    else if (userName === Persona__get_Name(new Persona(3, []))) {
        return icon(user_tie);
    }
    else if (userName === Persona__get_Name(new Persona(4, []))) {
        return icon(user_shield);
    }
    else {
        return defaultOf();
    }
}

export function UserName(key, userName) {
    let elems;
    return createElement("span", createObj(ofArray([["key", `${key}-username`], ["className", "flex items-center justify-left"], (elems = [UserIcon(userName), ` ${userName}`], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function UserDropdown(userDropdownInputProps) {
    let elems_1, elems, elems_4, elems_3, elems_2;
    const onClick = userDropdownInputProps.onClick;
    const translations = userDropdownInputProps.translations;
    const userName = userDropdownInputProps.userName;
    const key = userDropdownInputProps.$key;
    const logoutMenu = createElement("li", createObj(ofArray([["key", "user-logout"], (elems_1 = [createElement("a", createObj(ofArray([["key", "user-logout-link"], ["className", "whitespace-nowrap"], ["onClick", (_arg) => {
        onClick();
    }], (elems = [icon(arrow_right_from_bracket), createElement("span", {
        key: "user-logout-text",
        className: "ml-2",
        children: `${TranslationPages_Home__get_Logout(AppTranslations__get_Home(translations))}`,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    return createElement("div", createObj(Helpers_combineClasses("dropdown", ofArray([["className", "dropdown-hover"], ["className", "dropdown-end"], ["key", `${key}-dropdown`], ["className", "flex-none"], (elems_4 = [createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-ghost"], ["key", "user-button"], ["className", "opacity-80 hover:opacity-100"], ["children", icon(user_lock)]])))), createElement("ul", createObj(Helpers_combineClasses("dropdown-content", ofArray([["key", "user-dropdown-content"], ["className", "p-2 shadow menu bg-base-100 rounded-box"], ["tabIndex", 0], (elems_3 = [createElement("ul", createObj(ofArray([["key", "user-dropdown-list"], (elems_2 = [createElement("li", createObj(Helpers_combineClasses("menu-title", ofArray([["key", "user-dropdown-username"], ["className", "whitespace-nowrap"], ["children", UserName("user-dropdown", userName)]])))), logoutMenu], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
}

